import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';

const ScrollButton = styled.button<{ $visible: boolean }>`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  background: rgba(0, 0, 0, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  opacity: ${props => props.$visible ? '1' : '0'};
  transform: translateY(${props => props.$visible ? '0' : '20px'});
  transition: all 0.3s ease;
  z-index: 1000;
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;

  &:hover {
    background: var(--primary-color);
    border-color: var(--primary-color);
    transform: translateY(-2px);
  }

  .icon {
    font-size: 1.2rem;
  }

  .text {
    font-size: 0.6rem;
    font-family: var(--secondary-font-family);
    opacity: 0.8;
  }
`;

const ScrollToTop: FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <ScrollButton 
      $visible={isVisible}
      onClick={scrollToTop}
      aria-label="Retourner en haut de la page"
      title="Retourner en haut de la page"
    >
      <FontAwesomeIcon icon={faArrowUp} className="icon" />
      <span className="text">Haut</span>
    </ScrollButton>
  );
};

export default ScrollToTop;
